(function(){
    'use strict';

    $(window).on('load resize', function () {
        changepos();
        loadLinkGallery();
    });

    function changepos() {
        var toppos = ($('.smp-link-gallery .slick-current').find("img").height()/2);
        $('.smp-link-gallery .slick-arrow').css('top',toppos+'px');
    }

    function loadLinkGallery() {
        var settings = {
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            
            prevArrow: '<button type="button" class="slick-prev"><span class="fas fa-chevron-left"></span><span class="sr-only">Previous</span></button>',
            nextArrow: '<button type="button" class="slick-next"><span class="fas fa-chevron-right"></span><span class="sr-only">Next</span></button>',
            responsive: [
                {
                    breakpoint: 1199,
                    settings: "unslick"
                },
            {
                breakpoint: 991,
                settings: {
                slidesToShow: 2,
                slidesToScroll: 2
                }
            },
            {
                breakpoint: 767,
                settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '40px'
                }
            }
            ]
        };
        if($('.link-gallery-rows').length) {
            $('.link-gallery-rows').not('.slick-initialized').slick(settings).on('afterChange',function(event){
                var toppos = ($('.link-gallery-rows .slick-active').find("img").height()/2);
                $('.link-gallery-rows .slick-arrow').css('top',toppos+'px');
            }).trigger('afterChange');

            if ($(window).width() > 1199) {
                if ($('.link-gallery-rows').hasClass('slick-initialized')) {
                    $(".link-gallery-rows").not('.slick-initialized').slick(settings);
                }
                return
            }
        }
    }

}());
